import { email } from "@libs/validation/fieldValidators.ts";
import { Validator } from "@libs/validation/Validator.ts";

import { AccreditedBillingEmailDialogValues } from "./AccreditedBillingEmailDialog.types.ts";

export class AccreditedBillingEmailDialogValidator extends Validator<AccreditedBillingEmailDialogValues> {
  constructor() {
    super();
    this.forField("email", [email()]);
  }
}
